<template>
  <div class="attendance-calendar-component table-scrollable">

    <table class="table table-att-month">
      <thead>
      <tr>
        <th class="th-day-lock" :class="{'day-select-head': true, 'day-select-head--active': selectedDays.length}">
          <div class="dropdown">
            <i class="fas fa-ellipsis-v dropdown-toggle"></i>
            <div class="dropdown-menu" aria-labelledby="dropdownMenu">
              <a class="dropdown-item" v-if="selectedDays.length" @click="lockSelected" href="#"><i
                class="fa fa-lock text-success"></i>{{ trans.lock }}</a>
              <a class="dropdown-item" v-if="selectedDays.length" @click="unlockSelected" href="#"><i
                class="fa fa-unlock text-warning"></i> {{ trans.unlock }}</a>

              <a class="dropdown-item" @click="selectAllDays" href="#"><i class="fa fa-check"></i>{{ trans.selectAll }}</a>
              <a class="dropdown-item" @click="selectUntilYesterday" href="#"><i
                class="fa fa-calendar"></i>{{ trans.selectUntilYesterday }}</a>
              <a class="dropdown-item" @click="deselectAllDays" href="#"><i class="fa fa-times"></i>
                {{ trans.deselectAll }}</a>
            </div>
          </div>
        </th>
        <th class="th-date">{{ trans.date }}</th>
        <th class="th-shift-plan">{{ trans.shift_plan }}</th>
        <th class="th-flag-day p-0"></th>
        <th class="th-work-time">{{ trans.work_time }} ({{ trans.interval }})</th>
        <th class="th-total-time">{{ trans.total_time }}</th>
        <th class="th-actions-buttons">{{ trans.btn_actions }}</th>
      </tr>
      </thead>

      <tbody v-cloak>

      <template
        v-for="(day, index) in days"
      >
        <tr
          :key="index + 1"
          v-if="day.offDay"
          :class="{ 'holiday': day.offDay, 'weekend': day.isWeekend, 'is-hidden': day.workDay && day.workDay.is_hidden }"
        >
          <td></td>
          <td class="td-date pb-0" colspan="6">
            <span v-if="day.offDay" class="holiday">
              <i class="fas fa-star"></i>&nbsp;{{ day.offDay }}
            </span>
          </td>
        </tr>

        <tr
          :key="day.date"
          :class="{ 'weekend': day.isWeekend, 'is-hidden': day.workDay && day.workDay.is_hidden, 'holiday no-border': day.offDay }"
        >
          <td class="td-day-lock">
            <div class="d-flex align-items-center">
              <div class="day-select">
                <input type="checkbox" :id="'checkbox' + day.date" :checked="isDayChecked(day.date)"
                       @change="toggleSelectDay($event, day.date)" class="form-check-input">
                <label class="form-check-label" :for="'checkbox' + day.date"></label>
              </div>
              <div class="day-lock">
                <a
                  v-if="day.isLocked"
                  type="button"
                  class="btn text-success"
                  @click="toggleLocked(day, false)"
                  :class="{'loading disabled': toggleLoadingDate.some(item => item === day.date) }"
                >
                  <i class="fas fa-lock" v-if="!toggleLoadingDate.some(item => item === day.date)"></i>
                  <i class="loadingSpinner"></i>
                </a>
                <a
                  v-if="!day.isLocked"
                  type="button"
                  class="btn text-warning"
                  @click="toggleLocked(day, true)"
                  :class="{'loading disabled': toggleLoadingDate.some(item => item === day.date) }"
                >
                  <i class="fas fa-unlock" v-if="!toggleLoadingDate.some(item => item === day.date)"></i>
                  <i class="loadingSpinner"></i>
                </a>
              </div>
            </div>
          </td>

          <td class="td-date">
            <span class="date">
              <b>{{ day.date | date('DD') }}</b>
            </span>
            <span class="week-day">
              {{ day.date | date('dddd') }}
            </span>
          </td>

          <td class="td-shift-plan">
            <div v-for="(interval, index) in day.shiftPlan.intervals" :key="index">
              <span v-if="interval.from && interval.to">
                <span v-if="interval.planIntervalType === workType">
                  {{ interval.from | datetime('HH:mm') }} - {{ interval.to | datetime('HH:mm') }}
                </span>
                <span v-else>
                  {{ interval.planIntervalTypeLabel }} {{ intervalLength(interval.from,interval.to) }} h.
                </span>
              </span>
            </div>
          </td>

          <td class="td-flag-day">
            <span
              v-if="day.flagId"
              :class="'badge badge-flag badge-'+(day.flagId !== 2 ? 'info':'danger')"
              data-toggle="popover"
              :title="trans.flag[day.flagId]"
              v-b-popover.hover="trans.reason+': '+ (day.flagId === 3 ? '-' : (day.flagReason ? day.flagReason : '-'))"
            >
              <i class="fas fa-comment-dots fa-fw"></i>
            </span>
          </td>

          <td class="td-work-time">
            <div class="d-flex">
              <div v-if="day.workDay" class="work-hours">
                <div v-for="(interval, index) in day.workDay.intervals" :class="`interval-${index + 1}`" :key="index">

                  <template v-if="interval.work_interval_type == workType">
                    <span class="badge badge-dark" v-bind:key="interval.id">
                      {{ interval.from | datetime('HH:mm') }} - {{ interval.to | datetime('HH:mm') }}
                    </span>
                    <span class="badge badge-light">
                      {{ intervalLength(interval.from, interval.to) }}&nbsp;{{ trans.hours }}
                    </span>
                  </template>

                  <template v-if="interval.work_interval_type != workType">
                    <div class="work-holiday">
                      <span class="badge badge-holiday">
                        {{ interval.work_interval_type | localizedIntervalType(workIntervalTypes)
                                                }}
                                              </span>
                      <span class="badge badge-light">
                                                  {{ intervalLength(interval.from, interval.to) }}&nbsp;{{ trans.hours }}
                                              </span>

                      <b-badge v-if='dayHasProblem(day.workDay)' variant='danger' v-b-tooltip.hover
                               :title="trans.exclamationDayHasProblem" style="min-width:auto;">
                        <i class="fas fa-exclamation"></i>
                      </b-badge>
                    </div>
                  </template>
                </div>
              </div>
              <div v-else></div>

              <div v-if="day.workDay && getLegalChecksForDay(day.workDay).length > 0">
                <b-button :id="'popover-btn-legalcheck-day-'+day.workDay.id" variant="link"
                          @click="toggleLegalChecksPopoverVisibility(index)">
                  <span class="fas fa-2x fa-fw fa-exclamation-triangle text-danger"></span>
                </b-button>
                <b-popover :show.sync="popoversStates[index]" :workDayId="day.workDay.id"
                           :target="'popover-btn-legalcheck-day-'+day.workDay.id" placement="top">
                  <template slot="title">{{ trans.legal_checks_title }}</template>
                  <ul style="padding: 0; margin:0 0.8rem;">
                    <li v-for="x in getLegalChecksForDay(day.workDay)">
                      <span class="nl2br">{{ x.message }}</span>
                    </li>
                  </ul>
                </b-popover>
              </div>
            </div>
          </td>

          <td class="td-total-time">
            <div class="total-hours">
              <template v-if="day.workDay">
                                    <span v-if="day.workDay.intervals_sum" class="badge badge-success">
                                        {{ intervalSumFormat(day.workDay.intervals_sum) }}&nbsp;{{ trans.hours }}
                                    </span>
                <span v-if="day.workDay.number_of_night_shifts_hours !== '0'" class="badge badge-midnight">
                                        <i class="fa fa-moon"></i> {{
                    Number.parseFloat(day.workDay.number_of_night_shifts_hours).toFixed(2)
                  }}
                                    </span>
              </template>
            </div>
          </td>

          <td class="td-actions-buttons">
            <div v-if="!day.isLocked && day.workDay && day.workDay.intervals && day.workDay.intervals.length > 0"
                 class="btn-group"
            >
              <button
                @click="editWorkDay(day)"
                type="button"
                class="btn btn-warning btn-sm btn-square-loading"
                :class="{'loading disabled': (modalLoadingDate == day.date) }"
              >
                <i class="fal fa-fw fa-pencil" v-if="(modalLoadingDate != day.date)"></i>
                <i class="loadingSpinner"></i>
              </button>

              <button
                @click="deleteItem(day)"
                type="button"
                class="btn btn-danger btn-sm btn-square-loading"
                :class="{'loading disabled': (deleteLoadingDate == day.date) }"
              >
                <i class="fal fa-fw fa-trash-alt" v-if="(deleteLoadingDate != day.date)"></i>
                <i class="loadingSpinner"></i>
              </button>

              <button
                @click="handleChange(day)"
                type="button"
                class="btn btn-light btn-sm"
                v-if="day.workDay.number_of_all_absences_hours == 0 && day.workDay.intervals[0].work_interval_type == workType"
              >
                <i v-if="!day.workDay.is_hidden" class="far fa-fw fa-eye text-success"></i>
                <i v-else class="far fa-fw fa-eye-slash text-danger"></i>
              </button>

              <button
                @click="showHistory(day)"
                type="button"
                class="btn btn-secondary btn-sm btn-versionning"
                :disabled="!day.isVersioned"
              >
                <i class="fal fa-fw fa-history"></i>
              </button>
            </div>

            <div v-if="!day.isLocked && (!day.workDay || !day.workDay.intervals || day.workDay.intervals.length == 0)"
                 class="btn-group"
            >
              <button
                @click="editWorkDay(day)"
                type="button"
                class="btn btn-primary btn-sm btn-add-date"
                :class="{'loading disabled': (modalLoadingDate == day.date) }"
              >
                <i class="fal fa-fw fa-plus"></i>
                <i class="loadingSpinner"></i>
              </button>

              <button
                @click="showHistory(day)"
                type="button"
                class="btn btn-secondary btn-sm btn-versionning"
                :disabled="!day.isVersioned"
              >
                <i class="fal fa-fw fa-history"></i>
              </button>
            </div>
          </td>
        </tr>
      </template>

      </tbody>
    </table>

  </div>
</template>

<script>

export default {
  name: 'attendance-calendar',
  data: function () {
    return {
      toggleLoadingDate: [],
      deleteLoadingDate: null,
      selectedDays: [],
      popoversStates: [ // 31 items (days)
        false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
      ]
    }
  },

  props: {
    'days': {
      type: Array
    },
    'employeeContractId': {
      type: Number
    },
    'loading': {
      type: Boolean
    },
    'deleteUrl': {
      type: String
    },
    'lockUrl': {
      type: String
    },
    'lockEmptyDayUrl': {
      type: String
    },
    'unlockUrl': {
      type: String
    },
    'massTogglelockUrl': {
      type: String
    },
    'hideUrl': {
      type: String
    },
    'unhideUrl': {
      type: String
    },
    'trans': {
      type: Object
    },
    'workIntervalTypes': {
      type: Array
    },
    'workType': {
      type: String
    },
    'modalLoadingDate': {
      type: String
    },
    'workedHolidays': {
      type: Array
    },
    'legalChecks': {
      type: Array
    }
  },

  created() {
  },

  methods: {
    handleChange(day) {
      day.workDay.is_hidden = !day.workDay.is_hidden;
      this.toggleHidden(day, day.workDay.is_hidden);
    },

    editWorkDay(day) {
      this.$modal.show('edit-work-day', {day});
    },

    showHistory(day) {
      this.$modal.show('work-days-history-modal', {day});
    },

    toggleHidden(day, hide) {
      const workDay = day.workDay;
      let _this = this;
      let url = null;

      if (hide) {
        url = this.hideUrl + "/" + workDay.id;
      } else {
        url = this.unhideUrl + "/" + workDay.id;
      }

      axios.post(url).then(function (response) {
        _this.refreshCalendar();
        _this.refreshAttendance();

        _this.$notify({
          type: 'success',
          title: 'Success!',
          text: response.data.message ? response.data.message : 'Item successfully updated.'
        });
      }, function (error) {
        _this.refreshCalendar();
        _this.refreshAttendance();

        _this.$notify({
          type: 'error',
          title: 'Error!',
          text: error.response.data.message ? error.response.data.message : 'An error has occured.'
        });
      });
    },

    toggleLocked(day, lock) {
      const workDay = day.workDay;
      let _this = this;
      let url = null;

      this.toggleLoadingDate.push(day.date);

      if (lock) {
        url = workDay ? this.lockUrl + "/" + workDay.id : this.lockEmptyDayUrl + "/" + day.date + "/" + this.employeeContractId;
      } else {
        url = this.unlockUrl + "/" + workDay.id;
      }

      axios.post(url).then(function (response) {
        _this.refreshCalendar();
        _this.refreshAttendance(false);

        // _this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
        _this.toggleLoadingDate = _this.toggleLoadingDate.filter(item => item !== day.date);
      }, function (error) {
        _this.refreshCalendar();
        _this.refreshAttendance(false);

        _this.$notify({
          type: 'error',
          title: 'Error!',
          text: error.response.data.message ? error.response.data.message : 'An error has occured.'
        });
        _this.toggleLoadingDate = _this.toggleLoadingDate.filter(item => item !== day.date);
      });
    },

    massToggleLock(days, dates, operation) {
      let _this = this;
      for (var x in dates) {
        _this.toggleLoadingDate.push(dates[x]);
      }

      axios.post(this.massTogglelockUrl, {days: days, operation: operation}).then(function (response) {
        _this.refreshCalendar();
        _this.refreshAttendance(false);

        for (var x in dates) {
          _this.toggleLoadingDate = _this.toggleLoadingDate.filter(item => moment(item.date).date() == dates[x]);
        }
        //_this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
      }, function (error) {
        _this.refreshCalendar();
        _this.refreshAttendance(false);

        for (var x in dates) {
          _this.toggleLoadingDate = _this.toggleLoadingDate.filter(item => moment(item.date).date() == dates[x]);
        }
        _this.$notify({
          type: 'error',
          title: 'Error!',
          text: error.response.data.message ? error.response.data.message : 'An error has occured.'
        });
      });
    },

    deleteItem(day) {
      const workDay = day.workDay;
      let _this = this;

      var confirmText = _this.trans.deleteWarning.text;
      if (workDay.is_off_day && workDay.intervals[0].work_interval_type == 'work' && this.findWorkedHolidayPair(workDay.id)) {
        confirmText += "<p class='mt-2 text-danger'><b>" + _this.trans.deleteWarning.workedHoliday + "</b></p>";
      }

      this.$modal.show('dialog', {
        title: _this.trans.deleteWarning.title,
        text: confirmText,
        buttons: [{title: _this.trans.deleteWarning.no}, {
          title: '<span class="btn-dialog btn-danger">' + _this.trans.deleteWarning.ok + '<span>',
          handler: function handler() {
            _this.deleteLoadingDate = day.date;
            _this.$modal.hide('dialog');

            axios.delete(_this.deleteUrl + "/" + workDay.id).then(function (response) {
              _this.deleteLoadingDate = null;
              _this.refreshCalendar();
              _this.refreshAttendance();

              _this.$notify({
                type: 'success',
                title: 'Success!',
                text: response.data.message ? response.data.message : 'Item successfully deleted.'
              });
            }, function (error) {
              _this.deleteLoadingDate = null;
              _this.refreshCalendar();
              _this.refreshAttendance();

              _this.$notify({
                type: 'error',
                title: 'Error!',
                text: error.response.data.message ? error.response.data.message : 'An error has occured.'
              });
            });
          }
        }]
      });
    },

    refreshCalendar(withLoading = true) {
      this.$emit('refreshcalendar', withLoading);
    },
    refreshAttendance(withLoading = true) {
      this.$emit('refreshattendance', withLoading);
      this.$emit('refreshworkedholidays');
      this.$emit('refreshlegalchecks');
      this.$emit('refreshbalances');
    },
    isDayChecked(date) {
      return this.selectedDays.some(item => item === date);
    },
    toggleSelectDay(event, date) {
      const selected = event.target.checked;
      if (selected) {
        this.selectedDays.push(date);
      } else {
        this.selectedDays = this.selectedDays.filter(item => item !== date)
      }

      // DA-313: workaround for preventing auto-scroll calendar out-of-screeen
      // caused by overflow: hidden of #app (it is auto-scrolled by some vue core functionality (focus to clicked element? or something like that)
      document.getElementById('app').scrollTop = 0;
    },
    selectAllDays() {
      this.selectedDays = this.days.map(item => item.date);
    },
    selectUntilYesterday() {
      const yesterday = moment().subtract(1, 'day');
      this.selectedDays = this.days.filter(item => {
        return moment(item.date).isBefore(yesterday);
      }).map(item => item.date)
    },
    deselectAllDays() {
      this.selectedDays = []
    },
    lockSelected() {
      var arrDays = [];
      var arrDates = [];
      this.selectedDays.forEach(item => {
        const day = this.days.find(day => day.date === item);
        arrDates.push(day.date);
        arrDays.push(moment(day.date).date());
      });
      this.massToggleLock(arrDays, arrDates, "lock");
    },
    unlockSelected() {
      var arrDays = [];
      var arrDates = [];
      this.selectedDays.forEach(item => {
        const day = this.days.find(day => day.date === item);
        arrDates.push(day.date);
        arrDays.push(moment(day.date).date());
      });
      this.massToggleLock(arrDays, arrDates, "unlock");
    },

    dayHasProblem(day) {
      if (day.intervals[0].work_interval_type == 'nvp-holiday' && !this.findWorkedHolidayPair(day.id, true)) {
        return true;
      }

      return false;
    },

    findWorkedHolidayPair(dayId, searchAsCompensation) {
      for (var x in this.workedHolidays) {
        var item = this.workedHolidays[x];

        if (searchAsCompensation && item.compensated_by == dayId ||
          !searchAsCompensation && item.id_day == dayId && item.compensated_by) {
          return true;
        }
      }

      return false;
    },

    intervalLength(start, end) {
      const durationMinutes = moment.duration(moment(end).diff(moment(start))).asMinutes();

      const calcHours = (Math.floor(durationMinutes / 60));
      const calcMinutes = Math.floor(durationMinutes - calcHours * 60);

      return (calcHours < 10 ? "0" : "") + calcHours + ":" + (calcMinutes < 10 ? "0" : "") + calcMinutes;
    },

    intervalSumFormat(intervalsSumStr) {
      let arr = intervalsSumStr.split(":");
      return (arr[0] && arr[1] ? arr[0] + ":" + arr[1] : "(ERR)");
    },

    getLegalChecksForDay(workDay) {
      let arr = this.legalChecks.filter(x => x.workDayId === workDay.id);

      return arr ? arr : [];
    },

    toggleLegalChecksPopoverVisibility(index) {
      this.popoversStates.forEach((x, i) => {
        if (i === index) {
          this.popoversStates[i] = true;
        } else {
          this.popoversStates[i] = false;
        }
      });
    },
  },

  computed: {
    // a computed getter
    legalCheckPopoverActive: {
      // getter
      get: function (x, y, z) {
        return true;
      },
      // setter
      set: function (newValue) {
      }
    }
  },

  filters: {
    date: function date(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

      var date = (0, moment)(date);
      return date.isValid() ? date.format(format) : "";
    },
    datetime: function datetime(_datetime) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

      var date = (0, moment)(_datetime);
      return date.isValid() ? date.format(format) : "";
    },
    floatToTime: function floatToTime(number) {
      var date = new Date(number * 3600 /* sec per hr */
        * 1000 /* msec per sec */);
      return ('0' + date.getUTCHours()).slice(-2) + ':' +
        ('0' + date.getUTCMinutes()).slice(-2);
    },
    localizedIntervalType: function (key) {
      let item = arguments[1].find(x => x.key === key);
      return (item ? item.label : "???");
    }
  },
}
</script>


<style lang="scss">
.btn-square-loading,
.btn.loading.btn-square-loading {
  width: 36px;
  height: 31px;
  padding-right: 0.75rem !important;
  text-align: center;

  .loadingSpinner {
    margin-left: -8px;
    left: auto;
    right: auto;
  }
}

.btn-square-mini-loading,
.btn.loading.btn-square-mini-loading {
  width: 27px;
  height: 25px;
  padding-right: 0.75rem !important;
  text-align: center;

  .loadingSpinner {
    margin-left: -8px;
    left: auto;
    right: auto;
  }
}

.magic-switch {
  margin-left: 10px;
}

.td-work-time {
  vertical-align: middle;

  .d-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/show/AttendanceCalendar.vue